import { render, staticRenderFns } from "./Limits.vue?vue&type=template&id=7f365da8&"
import script from "./Limits.vue?vue&type=script&lang=ts&"
export * from "./Limits.vue?vue&type=script&lang=ts&"
import style0 from "./Limits.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports